import {GeometryEditsDispatcher} from '../core/dispatchers'
import {IGeometryEditsDispatcher} from '../core/interfaces/dispatchers'
class AppGeometryEditsDispatcher extends GeometryEditsDispatcher {}

export const appGeometryEditsDispatcher = new AppGeometryEditsDispatcher() as IGeometryEditsDispatcher
